import { render, staticRenderFns } from "./ContentPreviewModal.vue?vue&type=template&id=a227a046&scoped=true"
import script from "./ContentPreviewModal.vue?vue&type=script&lang=js"
export * from "./ContentPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ContentPreviewModal.vue?vue&type=style&index=0&id=a227a046&prod&lang=css"
import style1 from "./ContentPreviewModal.vue?vue&type=style&index=1&id=a227a046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a227a046",
  null
  
)

export default component.exports